const A = 'active'
const C_SHOW = 'show-types-slider'
const types = document.getElementById('types');
const mainNav = document.querySelector('.js-main__nav');
const typesNav = document.querySelectorAll('.js-types-nav');
let slider = null;


/**
 * @return {string}
 */
const SF_TYPES_IMG = function (id) {
  return `.js-types-img[data-nav="${id}"]`
};

/**
 * @return {string}
 */
const SF_TYPES_IMG_NOT = function (id) {
  return `.js-types-img:not([data-nav="${id}"])`;
};

const addClass = function (C) {
  this.classList.add(C)
}

const removeClass = function (C) {
  this.classList.remove(C)
}

const mouseenterMainNav = function () {
  if(window.innerWidth >= 768){
    addClass.call(document.body, C_SHOW)
  }
}
const mouseleaveMainNav = function () {
  removeClass.call(document.body, C_SHOW)
}
const mouseenterTypesNav = function () {
  addClass.call(this, A)
  if(window.innerWidth >= 768 && slider){
    let id = this.getAttribute('data-nav');
    if (id !== undefined) {
      slider.goTo(id);
      document.querySelectorAll(SF_TYPES_IMG_NOT(id))
        .forEach(function (value) {
          removeClass.call(value, A)
      })
      document.querySelectorAll(SF_TYPES_IMG(id)).forEach(function (value) {
          addClass.call(value, A)
      })

    }
  }
}
const mouseleaveTypesNav = function () {
  typesNav.forEach(function (value) {
    removeClass.call(value, A)
  })
}

export default function () {
  if(!types){
    return false
  }
  if(slider){
    slider.destroy()
  }
  slider = window.tns({
    "autoWidth": true,
    "items": 3.3,
    "gutter": 10,
    "touch": false,
    "mouseDrag": false,
    "center": true,
    "swipeAngle": false,
    "controls": false,
    "nav": false,
    "navAsThumbnails": false,
    "container": types,
    "speed": 400
  });

  on(mainNav, 'mouseenter', mouseenterMainNav)
  on(mainNav, 'mouseleave', mouseleaveMainNav)
  typesNav.forEach(function (value) {
    on(value, 'mouseenter', mouseenterTypesNav)
    on(value, 'mouseleave', mouseleaveTypesNav)
  })
}
